<template>
  <div class="login-container">
    <div class="login-form blur-bg">
      <!-- <img src="../assets/logo.png"
           title="logo" /> -->
      <div class="login-input">
        <span class="login-icon">&#59259;</span>
        <u-text-box placeholder="请输入用户名"
                    v-model="loginForm.account"
                    type="text" />
      </div>
      <div class="login-input">
        <span class="login-icon">&#59182;</span>
        <u-text-box placeholder="请输入密码"
                    v-model="loginForm.password"
                    type="password"
                    @keyup.enter.native="login" />
      </div>
      <div class="login-opt">
        <span><input type="checkbox"
                 v-model="loginForm.remember"
                 class="option-checkbox"
                 id="checkbox1">
          <label for="checkbox1">记住密码</label>
        </span>
        <span @click="goToD5Reset">忘记密码</span>
      </div>
      <u-button @click.native.prevent="login"
                class="btn">登录</u-button>
    </div>
  </div>
</template>
<script>
// import { Message } from 'element-ui'
import { SUCCESS } from '@config/code.js'
import { goToD5Reset } from '@utils/app.js'
import {
  getAccount,
  getPassword,
  deletePassword,
  getUserName,
} from '@utils/auth.js'

export default {
  data() {
    return {
      loginForm: {
        account: '',
        password: '',
        remember: false,
      },
      loading: false,
      baseUrl: process.env.BASE_URL
    }
  },
  mounted() {
    this.loadUserInfo()
  },
  methods: {
    goToD5Reset() {
      this.loginForm.password = ''
      return goToD5Reset()
    },
    loadUserInfo() {
      if (getAccount()) {
        this.loginForm.account = getAccount()
        this.loginForm.password = getPassword()
        this.loginForm.remember = true
      } else {
        deletePassword()
        this.loginForm.account = getUserName()
        this.loginForm.remember = false
      }
    },
    loginErrCallback() {
      this.$store.commit('showMsgBox', false)
    },
    login() {
      if (this.doesLoginErr()) {
        this.handleLoginErr()
      } else {
        this.loginForm.account = this.loginForm.account.trim()
        ;(async() => {
          try {
            const { code } = await this.$store.dispatch('_Login', this.loginForm)
            if (code === SUCCESS) {
              await this.$store.dispatch('_GetInfo')

              this.$router.push({ path: '/' })
            }
          } catch (err) {
            console.log(err)
          }
        })()

        // this.$store.dispatch('_Login', this.loginForm)
      }
    },
    doesLoginErr(){
      return this.loginForm.account === '' || this.loginForm.password === ''
    },
    handleLoginErr() {
      this.$store.commit('setMsgBox', {
        visible: true,
        message: '账户名、密码不能为空',
        onConfirm: this.loginErrCallback,
        onClose: this.loginErrCallback,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@src/styles/variables.scss';

.login-container {
  height: 100%;
  width: 100%;
  background: url('../assets/images/bg.jpg') left top / cover no-repeat;
  .login-form {
    border-radius: 10px;
    text-align: center;
    padding: 30px 45px;
    width: 400px;
    height: 440px;
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: 180px auto 0;
    // background: rgba(21, 20, 20, 0.5);
    .btn {
      height: 48px;
      width: 100%;
      font-size: 17px;
      margin: 0;
      background: $color-bg-hover;
      border: none;
      &:hover {
        background: $color-text-title;
        border: none;
      }
    }
    img {
      width: 12rem;
      height: 5rem;
      margin: 30px 0 40px 0;
    }
    .login-input {
      position: relative;
      margin-bottom: 20px;
      span {
        position: absolute;
        top: 16px;
        left: 8px;
        font-size: 14px;
        color: #969690;
      }
      input {
        width: 100%;
        height: 48px;
        padding-left: 32px;
        &:-webkit-autofill {
          box-shadow: 0 0 0px 1000px #fff inset !important;
          -webkit-text-fill-color: #000 !important;
          border-color: #0078d7;
        }
      }
    }
    .login-opt {
      height: 48px;
      line-height: 48px;
      display: flex;
      justify-content: space-between;
      margin-top: -20px;
      span {
        cursor: pointer;
        display: flex;
        align-items: center;
      }
      input[type='checkbox'] {
        cursor: pointer;
        width: 17px;
        height: 17px;
        background: none;
        -webkit-appearance: none;
        border: 2px solid rgba(255, 255, 255, 0.8);
        border-radius: 2px;
        outline: none;
        margin-right: 5px;
        &:hover {
          border-color: #fff;
        }
        &:checked {
          background: url('../assets/images/checked.png') no-repeat;
          border: none;
          background-size: 100% 100%;
        }
      }
    }
  }
}
</style>


